import { MdInfoOutline } from '../../icons';

import { IconTooltip, IconTooltipProps } from './IconTooltip';

export type InfoTooltipProps = Pick<IconTooltipProps, 'content' | 'size' | 'iconSize' | 'data-testid'>;

export const InfoTooltip = (props: InfoTooltipProps) => {
  return <IconTooltip icon={MdInfoOutline} colour="fg.muted" data-testid="info-tooltip" {...props} />;
};
